<template>
  <b-card>
    <!-- form -->
    <validation-observer ref="editEpi">
      <b-form
        v-if="epiPrepare"
        class="mt-2"
        @submit.prevent="handleSubmit"
        @keydown.enter="handleSubmit"
      >
        <b-row>
          <b-col cols="12">
            <h4 class="mb-2">
              {{ $t('DetallesEpi') }}
            </h4>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                :name="$t('Producto')"
                rules="required"
            >
              <b-form-group
                  :label="$t('Producto')"
                  label-for="epi-product"
              >
                <SelectProducts v-model="product" type="epi" :readonly="true"/>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                :name="$t('Estado')"
                rules="required"
            >
              <b-form-group
                  :label="$t('Estado')"
                  label-for="epi-status"
              >
                <v-select
                    v-model="status"
                    label="alias"
                    :filterable="false"
                    :searchable="false"
                    :options="selectStatus"
                    :placeholder="$t('Estado')"
                    :readonly="false"
                    :disabled="currentRole && (currentRole !== 'admin_cliente' && currentRole !== 'super_admin' && currentRole !== 'admin_empresa')"
                >
                  <template
                      slot="option"
                      slot-scope="option"
                  >
                    {{ $t('status.epis.' + option.alias) }}
                  </template>
                  <template
                      slot="selected-option"
                      slot-scope="option"
                  >
                    {{ $t('status.epis.' + option.alias) }}
                  </template>
                </v-select>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('NumeroSerie')"
              rules="required"
            >
              <b-form-group
                :label="$t('NumeroSerie')"
                label-for="epi-serial_number"
              >
                <b-form-input
                  v-model="epi.serial_number"
                  name="serial_number"
                  :placeholder="$t('NumeroSerie')"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <b-form-group
              :label="$t('NumeroAlbaran')"
              label-for="epi-pedido_num_id"
            >
              <b-form-input
                v-model="epi.pedido_num_id"
                name="pedido_num_id"
                :placeholder="$t('NumeroAlbaran')"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group
                :label="$t('FechaCompra')"
                label-for="epi-purchase_date"
            >
              <flat-pickr
                  v-model="purchase_date"
                  name="purchase_date"
                  class="form-control"
                  readonly="true"
                  :disabled="true"
              />
            </b-form-group>
          </b-col>
          <b-col sm="6" v-if="currentCompany.id === 3">
            <validation-provider
                #default="{ errors }"
                :name="$t('Coste')"
                rules=""
            >
              <b-form-group
                  :label="$t('Coste')"
                  label-for="equipos-coste"
              >
                <b-input-group append="€">
                  <b-form-input
                      v-model="epi.coste"
                      name="equipos-coste"
                      type="number"
                      :placeholder="$t('Coste')"
                  />
                </b-input-group>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
                #default="{ errors }"
                :name="$t('Localizacion')"
                rules=""
            >
              <b-form-group
                  :label="$t('Localizacion origen')"
                  label-for="epi-location"
              >
                <v-select
                    v-model="location"
                    label="name"
                    :filterable="false"
                    :searchable="false"
                    :options="selectLocations"
                    :placeholder="$t('Localizacion')"
                    :disabled="currentRole && (currentRole !== 'admin_cliente' && currentRole !== 'super_admin' && currentRole !== 'admin_empresa')"
                    readonly="readonly"
                >
                  <template
                      slot="option"
                      slot-scope="option"
                  >
                    {{ option.name }}
                  </template>
                  <template
                      slot="selected-option"
                      slot-scope="option"
                  >
                    {{ option.name }}
                  </template>
                </v-select>
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="6">
            <validation-provider
              #default="{ errors }"
              :name="$t('ProximaRevision')"
              rules=""
            >
              <b-form-group
                :label="$t('ProximaRevision')"
                label-for="epi-next_review"
              >
                <flat-pickr
                  v-model="next_review"
                  name="next_review"
                  class="form-control"
                  :readonly="true"
                  :disabled="true"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <b-col sm="12">
            <validation-provider
              #default="{ errors }"
              :name="$t('Descripcion')"
              rules=""
            >
              <b-form-group
                :label="$t('Descripcion')"
                label-for="epi-description"
              >
                <quill-editor
                  v-model="epi.description"
                />
              </b-form-group>
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-col>
          <!--<b-col sm="12">
            <b-form-group
                :label="$t('Documentos')"
                label-for="epi-documents"
            >
              <ImageDropzone
                  ref="documents"
                  :files="files"
                  maxFiles="10"
              />
            </b-form-group>
          </b-col>-->
          <b-col cols="12 text-right">
            <b-button
              type="submit"
              variant="primary"
              class="mt-2 mr-1"
            >
              {{ $t('Enviar') }}
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BForm, BFormGroup, BFormInput, BRow, BCol, BCard, BInputGroup,
} from 'bootstrap-vue'
import { quillEditor } from 'vue-quill-editor'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'
import Ripple from 'vue-ripple-directive'
import flatPickr from 'vue-flatpickr-component'
import { FlatPickrToTimestamp, TimestampToFlatPickr } from '@/libs/helpers'
import ImageDropzone from '@/components/elements/ImageDropzone/ImageDropzone.vue'
import vSelect from 'vue-select'
import SelectProducts from '@/components/selectProducts/SelectProducts.vue'

export default {
  components: {
    SelectProducts,
    BButton,
    BForm,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BRow,
    BCol,
    BCard,
    ValidationProvider,
    ValidationObserver,
    flatPickr,
    quillEditor,
    vSelect,
    ImageDropzone,
  },
  directives: {
    Ripple,
  },
  data() {
    return {
      last_review: '',
      purchase_date: '',
      next_review: '',
      product: '',
      user: '',
      files: [],
      status: '',
      required,
      email,
      epiPrepare: false,
      location: '',
    }
  },
  computed: {
    ...mapGetters({
      localeDatePicker: 'languages/getLocaleDatePicker',
      selectStatus: 'epis/getSelectStatus',
      currentClient: 'clients/getCurrentClient',
      currentCompany: 'companies/getCurrentCompany',
      selectDepartments: 'departments/getSelectDepartments',
      selectLocations: 'locations/getSelectLocations',
      epi: 'epis/getEpi',
      currentRole: 'auth/getRole',
    }),
  },
  methods: {
    ...mapActions({
      edit: 'epis/edit',
      getEpi: 'epis/getEpi',
      getSelectStatus: 'epis/selectStatus',
      getSelectDepartments: 'departments/selectDepartments',
      getSelectLocations: 'locations/getSelectLocations',
    }),
    handleSubmit() {
      this.$refs.editEpi.validate().then(success => {
        if (success) {
          const formData = this.createFormData()
          if (formData) {
            this.edit({ id: this.epi.id, epi: formData })
          }
        }
      })
    },
    createFormData() {
      // const data = this.$refs.documents.getFormData('documents')
      const data = new FormData()
      // data.append('purchase_date', FlatPickrToTimestamp(this.purchase_date))

      data.append('name', this.epi.name)
      data.append('status_id', this.status.id)
      if (this.location) {
        //data.append('location_id', this.location.id)
        data.append('origin_location_id', this.location.id)
      }
      data.append('serial_number', this.epi.serial_number)
      data.append('pedido_num_id', this.epi.pedido_num_id)
      data.append('description', this.epi.description)
      data.append('coste', this.epi.coste)
      // data.append('product_id', this.product.id)

      return data
    },
    setData() {
      if (this.epi.last_review) {
        this.last_review = TimestampToFlatPickr(this.epi.last_review)
      }
      if (this.epi.next_review) {
        this.next_review = TimestampToFlatPickr(this.epi.next_review)
      }
      if (this.epi.purchase_date) {
        this.purchase_date = TimestampToFlatPickr(this.epi.purchase_date)
      }
      if (this.epi.documents.length > 0) {
        const aux = this
        this.epi.documents.forEach((element, index) => {
          const file = {
            name: `File ${index + 1}`,
            url: element.path,
            urlDelete: `/epis/delete_doc/${aux.epi.id}/${element.id}`,
          }
          this.files.push(file)
        })
      }
      if (this.epi.user) {
        this.user = this.epi.user
      }
      if (this.epi.status) {
        this.status = this.epi.status
      }
      /*if (this.epi.location_relation) {
        this.location = this.epi.location_relation
      }*/
      if (this.epi.originLocation) {
        this.location = this.epi.originLocation
      }
      if (this.epi.product) {
        this.product = this.epi.product
      }
      this.epiPrepare = true
    },
  },
  async created() {
    await this.getEpi(this.$route.params.id)
    await this.setData()
    await this.getSelectStatus()
    await this.getSelectDepartments({ clients: [this.currentClient] })
    await this.getSelectLocations({ clients: [this.currentClient.id] })
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
.form-control:disabled{
  background-color: #f8f8f8 !important;
}
</style>
